import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import UploadModal from '@app/components/Modal/UploadModal';
import { getIsTrialPlanAppliedToday } from '@app/features/subscription/state';
import useContractSetupDocumentFileUpload from '@app/hooks/documentSetup/useContractSetupDocumentFileUpload';
import pushDataLayer from '@app/libs/analytics/googleTagManager';

interface SigningRequestUploadModalProps {
  isOpen: boolean;
  onClose: () => void;
}

function SigningRequestUploadModal({ isOpen, onClose }: SigningRequestUploadModalProps) {
  const isTrialPlanAppliedToday = useSelector(getIsTrialPlanAppliedToday);

  const { isLoading, mutateAsync: uploadDocumentFile } =
    useContractSetupDocumentFileUpload('documents');

  useEffect(() => {
    pushDataLayer({ event: 'viewSigningRequestUploadModal' });
  }, []);

  return (
    <UploadModal
      initialSideBarMenu={isTrialPlanAppliedToday ? 'SAMPLE_DOCUMENTS' : 'LOCAL'}
      isLoading={isLoading}
      isOpen={isOpen}
      needDraft
      needTemplate
      onClose={onClose}
      onSubmit={(file) => uploadDocumentFile(file).then(onClose)}
    />
  );
}

export default SigningRequestUploadModal;
